export default __webpack_public_path__ + "static/media/funktionar.6961336a.webp";